import { LR_COOKIE } from "../cookies/constants";
import { setFeedCookie } from "../cookies/library";
import { PROFILE_PATH } from "../../constants/account";
import importMF from "../../federated/importMF";
import { ACC_MODULES } from "../../federated/accountCentre";

export const setLoginRadiusCookie = (tokenKey) => {
    setFeedCookie(LR_COOKIE, tokenKey, 365);
};

export const deleteLoginRadiusCookie = () => {
    setFeedCookie(LR_COOKIE, "", -1);
};

export const loginViaAccountCentreRedirect = (returnto, referrer) => {
    // if the user is authenticated - then redirect to account centre
    const domain = window.location.origin;
    const loginURL = new URL("/account/login", domain);
    loginURL.searchParams.append("returnto", returnto);
    loginURL.searchParams.append("referrer", referrer);
    return loginURL;
};

export const profileViaAccountCentre = () => {
    const domain = window.location.origin;
    const accountCentreUrl = new URL(PROFILE_PATH, domain);
    return accountCentreUrl;
};

export const loadMembershipActionsLR = async () => {
    try {
        const [
            loadLoginRadius,
            checkLoggedInStatus,
            validateAccessToken,
            logout,
            getSessionToken,
        ] = await Promise.all([
            importMF(ACC_MODULES.loadLoginRadius),
            importMF(ACC_MODULES.checkLoggedInStatus),
            importMF(ACC_MODULES.validateAccessToken),
            importMF(ACC_MODULES.logout),
            importMF(ACC_MODULES.getSessionToken),
        ]);
        // Load login radius before returning membership actions
        await loadLoginRadius();

        if (window.LR_IS_READY) {
            return {
                checkLoggedInStatus,
                validateAccessToken,
                logout,
                getSessionToken,
            };
        } else {
            throw new Error(
                "Membership login radius failed to load. window.LR_IS_READY is not defined"
            );
        }
    } catch (error) {
        throw new Error(`loadMembershipActionsLR error [${error.message}]`, {
            cause: error,
        });
    }
};
